import { Portal } from '@mui/material';
import  NAV_LOGO  from '../assets/logos/World_O_Tutor.webp';
import { LOADING } from '../assets/animated';

export default function SplashScreen() {
  return (
    <Portal>
      <div className="w-full min-h-screen bg-white flex items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-4">
          <img src={LOADING} className="w-10 h-10" />
          <img src={NAV_LOGO} alt="WorldOTutor logo" className="h-10" />
        </div>
      </div>
    </Portal>
  );
}
